import React, { Component } from 'react';

export class Home extends Component {
  displayName = Home.name

  render() {
    return (
      <div>
        <h1>Centar za podršku</h1>
        <h4>CentarZaPodršku.WEB</h4>
        <p>&nbsp;</p>

        <p>Namjena aplikativne informatičke podrška Aplikativni sustava Centar za podršku je omogućiti službi koja daje podršku (MENTORI) osobama sa teškoćama u razvoju (KORISNICI)  pri njihovom svakodnevnom uključivanju u društvo sa posebnim naglaskom na zaposlenje i obavljanje svakodnevnih poslova.</p>
        <p>&nbsp;</p>
        <p>
          Web aplikacija Centar za podršku („CentarZaPodršku.WEB“) u kojem se na centralnom mjestu unose i prikupljaju svi podaci potrebni za funkcioniranje aplikacije. Baza podataka u koju se pohranjuju podaci će biti kreirana po projektnom zadatku a sa ciljem urednog funkcioniranja svih aplikativnih modula i sa mogućnošću naknadne analize podataka u svrhu unapređenja projekta „CentarZaPodršku“. Web aplikaciju koriste Mentori za unos i uređivanje podataka vezanih na Korisnike te Administratori za svoje poslove.
        </p>
        <p>&nbsp;</p>
        <p>
          Za rad sa aplikacijom CentarZaPodršku.WEB potrebno je pokrenuti prijavu i prijaviti se korisničkim podacima.
        </p>
      </div >
    );
  }
}
